import { nanoid } from 'nanoid/non-secure';

import { MESSAGES } from '../../constants';

export interface ISuggestionItem {
  readonly _id: string;
  readonly link: string;
  readonly title: string;
  readonly price: string;
}

export interface ISuggestionSelector {
  readonly id: string;
  readonly type: MESSAGES.SUGGESTION_SELECTOR;
  readonly rm: boolean;
  readonly nodeId: string;
  readonly pageSize: number;
  readonly items: ISuggestionItem[];
  readonly finishLink: string;
  readonly role?: string;
}

export const createSuggestionSelector = (data): ISuggestionSelector => ({
  id: nanoid(),
  type: MESSAGES.SUGGESTION_SELECTOR,
  rm: Boolean(data.rm),
  nodeId: data.nodeId,
  pageSize: data.pageSize,
  items: data.items,
  finishLink: data.finishLink,
});
